// services/authService.ts
import { apiService } from './api';
import { ResetPasswordRequest, OTPVerifyRequest, ChangePasswordRequest, ChangePasswordResponse } from '../types/index';

class AuthService {
    async login(username: string, password: string): Promise<any> {
      const response = await apiService.post('/login/', { username, password });
      if (response.access) {
        apiService.setAuthToken(response.access);
        localStorage.setItem('token', response.access);
        
        if (response.refresh) {
          localStorage.setItem('refresh_token', response.refresh);
        }
      }
      
      if (response.user) {
        localStorage.setItem('user', JSON.stringify(response.user));
      }
      
      return response;
    }
    
    async logout(): Promise<void> {
      const refreshToken = localStorage.getItem('refresh_token');
      if (refreshToken) {
        try {
          await apiService.post('/logout/', { refresh: refreshToken });
        } catch (error) {
          console.error('Logout error:', error);
        }
      }
      apiService.clearAuthToken();
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      localStorage.removeItem('refresh_token');
    }

  async verifyOTP(data: OTPVerifyRequest): Promise<{ success: boolean; message: string }> {
    return apiService.post('/auth/verify-otp/', data);
  }

  // Request password reset OTP
  async requestPasswordReset(email: string): Promise<{ success: boolean; message: string }> {
    return apiService.post('/auth/request-password-reset/', { email });
  }
  // Reset password
  async resetPassword(data: ResetPasswordRequest): Promise<{ success: boolean; message: string }> {
    return apiService.post('/auth/reset-password/', data);
  }
  /**
   * Change password for authenticated user
   */
  async changePassword(data: ChangePasswordRequest): Promise<ChangePasswordResponse> {
    const response = await apiService.post<ChangePasswordResponse>('/change-password/', data);
    
    // If new tokens are provided, update them
    if (response.access) {
      apiService.setAuthToken(response.access);
      localStorage.setItem('token', response.access);
    }
    
    if (response.refresh) {
      localStorage.setItem('refresh_token', response.refresh);
    }
    
    return response;
  }
}


// Export singleton instance
export const authService = new AuthService();